import { faX } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

/**
 *
 * @param props
 *  @param props.title Title of the modal
 *  @param props.className Optional class name for the modal container
 *  @param props.children Content of the modal - this will render any elements passed in directly
 * @returns
 */
export default function ExternalStateModalWidget(props: {
    visible: boolean,
    extraCloseButton?: React.ReactNode,
    title: string,
    width?: string,
    height?: string,
    top?: string,
    className?: string,
    clickingOverlayClosesModal?: boolean,
    showDefaultCloseButton?: boolean,
    closeModalCallback: () => void,
    children: React.ReactNode
}) {
    return <div className={props.className}>
        <div
            style={{
                position: "fixed",
                top: "0",
                zIndex: 1,
                left: "0",
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0, 0, 0, 0.33)",
                display: props.visible ? "block" : "none"
            }}
            onClick={() => {
                if (props.clickingOverlayClosesModal ?? true) props.closeModalCallback();
            }}>
            <div style={{
                backgroundColor: "white",
                boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
                // borderRadius: "5px",
                padding: "20px",
                width: props.width ?? (window.innerWidth < 1152 ? "75vw" : "45vw"),
                height: props.height ?? "fit-content",
                position: "fixed",
                top: props.top ?? "15vh",
                zIndex: 7,
                left: (window.innerWidth < 1152 ? "10vw" : "30vw"),
                display: props.visible ? "block" : "none"
            }}
            >

                <div className="d-flex flex-row fs-5" style={{ borderBottom: "3px solid orange" }}>
                    {props.title}
                    {props.showDefaultCloseButton && <div className="ms-auto btn my-auto"
                        onClick={() => {
                            props.closeModalCallback();
                        }}
                        style={{ cursor: "pointer" }}
                        role="button" aria-label="Close modal" aria-expanded="false"
                    ><FontAwesomeIcon icon={faX} /></div>}

                </div>
                <div className="d-flex flex-column my-3">
                    {props.children}
                </div>
                <div className="d-flex flex-column my-3">
                    <div>
                        {props.extraCloseButton}
                    </div>
                </div>
            </div>
        </div>
    </div >
}